const TESTERS_KEYWORD = "testers";

function splitSiteIds(raw: string | undefined): string[] {
  if (!raw) return [];
  return raw
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

/** The `testers` entry in any site list expands to `VITE_FF_TESTER_SITES`. */
function parseSiteList(raw: string | undefined): ReadonlySet<string> {
  return new Set(
    splitSiteIds(raw).flatMap((id) =>
      id === TESTERS_KEYWORD
        ? splitSiteIds(import.meta.env.VITE_FF_TESTER_SITES)
        : [id],
    ),
  );
}

export function createSiteAllowlistFlag(
  globalRaw: string | undefined,
  sitesRaw: string | undefined,
): (siteId: string | undefined) => boolean {
  const globalEnabled = globalRaw === "true";
  const enabledSites = parseSiteList(sitesRaw);
  return (siteId) => {
    if (globalEnabled) return true;
    if (!siteId) return false;
    return enabledSites.has(siteId);
  };
}

/**
 * Allowlist flag driven by a single env var that is either `true`
 * (enable everywhere) or a comma-separated list of site ids.
 */
export function createSiteAllowlistFlagFromVar(
  raw: string | undefined,
): (siteId: string | undefined) => boolean {
  return createSiteAllowlistFlag(raw, raw);
}
